module.exports = __webpack_public_path__ + "static/about_us_homepage_image-d6f39fa3c53a8cbaf0204c396b946cd5.jpg";